import type { ToteEngagementMode } from '@mote/api'
import type { CarouselMap } from './useCarousel'
import { useCarousel } from './useCarousel'

export type UseLoopEngage = {
  engage: (variables: any) => Promise<any>
  getImageForMode: (mode: ToteEngagementMode) => string
  forceRotate: (newCarouselMap: CarouselMap) => void
}

export function useLoopEngage(
  engage: UseLoopEngage['engage'],
  carouselMap: CarouselMap
): UseLoopEngage {
  const carousel = useCarousel(carouselMap)
  return {
    engage: async variables => {
      const response = await engage({ variables })
      if (response.error || !response.data) {
        return
      }
      carousel.rotate(response.data.device)
      return response.data
    },
    getImageForMode: mode => carousel.first(mode),
    forceRotate: newCarouselMap => carousel.rotate(newCarouselMap)
  }
}
